import PeopleIcon from "@mui/icons-material/People";
import EventIcon from "@mui/icons-material/Event";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import NightlightIcon from "@mui/icons-material/Nightlight";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import AppsIcon from "@mui/icons-material/Apps";
import User from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/User";
import { AccessRoleType } from "../types/AccessRoleType";
import SummarizeIcon from "@mui/icons-material/Summarize";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import VerifiedIcon from "@mui/icons-material/Verified";
import CommandActionSection from "../external/ensolvers-core-frontend-mui/types/CommandActionSection";
import MonitorOutlinedIcon from "@mui/icons-material/MonitorOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import StorageIcon from "@mui/icons-material/Storage";
import CommandAction from "../external/ensolvers-core-frontend-mui/types/CommandAction";
import AlarmAddIcon from "@mui/icons-material/AlarmAdd";
import BallotIcon from "@mui/icons-material/Ballot";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { Routes } from "../types/Routes";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DashboardIcon from "@mui/icons-material/Dashboard";
import RoleUtils from "./RoleUtils";
import { useHistory } from "react-router-dom";
import { Navigation } from "./enums/Navigation";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { Web } from "@mui/icons-material";
import StarsIcon from "@mui/icons-material/Stars";
import ImagesearchRollerIcon from "@mui/icons-material/ImagesearchRoller";

import SettingsIcon from "@mui/icons-material/Settings";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

export const STATIC_ICONS: ItemType = {
  userIcon: <PeopleIcon />,
  timeOffIcon: <EventIcon />,
  projectIcon: <CreateNewFolderIcon />,
  candidatesIcon: <PeopleAltIcon />,
  tasksIcon: <VerifiedUserIcon />,
  workLogIcon: <MoreTimeIcon />,
  reportIcon: <SummarizeIcon />,
  RecruitingEventIcon: <AssessmentIcon />,
  positionIcon: <AccessibilityIcon />,
  holidayIcon: <NightlightIcon />,
  assignationIcon: <AssignmentIndIcon />,
  worklogsSummaryIcon: <HourglassEmptyIcon />,
  certificationIcon: <VerifiedIcon />,
  assignationProjectionIcon: <BallotIcon />,
  certificationsIcon: <ListAltIcon />,
  knowledgeBaseIcon: <StorageIcon />,
  imagesearchRollerIcon: <ImagesearchRollerIcon />,
  dashboardIcon: <DashboardIcon />,
  vacationReportIcon: <BeachAccessIcon />,
  faqSectionIcon: <HelpRoundedIcon />,
  siteSectionIcon: <Web />,
  badgesSectionIcon: <MilitaryTechIcon />,
  timeOffMissingHoursIcon: <AccessAlarmIcon />,
  worklogMissingHoursIcon: <AlarmAddIcon />,
  projectionIcon: <AutoStoriesIcon />,
  projectTimelineIcon: <DateRangeIcon />,
  workLogReportsIcon: <SummarizeIcon />,
  propertiesSectionIcon: <SettingsIcon />,
  rankingIcon: <EmojiEventsIcon />,
  accomplishmentIcon: <StarsIcon />,
  accomplishmentApprovalIcon: <BallotIcon />,
  growthChallengeIcon: <TrendingUpIcon />,
};

export const getSections = (
  user: User,
  isDashboardFeatureEnabled: boolean | undefined,
  isVacationReportEnabled: boolean | undefined,
  isAccomplishmentEnabled: boolean | undefined,
  isCertificationEnabled: boolean | undefined,
) => {
  const excludedKeys: string[] = [];

  if (!isDashboardFeatureEnabled) {
    excludedKeys.push("dashboard");
  }

  if (!isVacationReportEnabled) {
    excludedKeys.push("vacationReport");
  }

  if (!isAccomplishmentEnabled) {
    excludedKeys.push("myAccomplishments");
    excludedKeys.push("accomplishmentApproval");
    excludedKeys.push("ranking");
  }

  if (!isCertificationEnabled) {
    excludedKeys.push("certifications");
  }

  const shouldIncludeRoute = (route: CommandAction) => !excludedKeys.includes(route.key);

  const hasAccess = (route: CommandAction, user: User) =>
    route.roles.some((role) => user.roles.some((accessRole) => accessRole.name === role));

  const userSections = sections
    .filter((section) => {
      const routesActions = section.items.filter((route) => shouldIncludeRoute(route) && hasAccess(route, user));

      return routesActions.length > 0;
    })
    .map((section) => ({
      key: section.key,
      label: section.label,
      icon: section.icon,
      items: section.items
        .filter((route) => shouldIncludeRoute(route) && hasAccess(route, user))
        .map((route) => ({
          ...route,
          icon: route.icon ?? (route.iconKey ? STATIC_ICONS[route.iconKey] : undefined),
        })),
    }));

  return userSections;
};

export const sections: CommandActionSection[] = [
  {
    key: "me",
    label: "Me",
    icon: <PeopleIcon />,
    items: [
      {
        key: "dashboard",
        iconKey: "dashboardIcon",
        actionPath: Routes.DASHBOARD,
        label: "Dashboard",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.DASHBOARD],
      },
      /*{
        key: "profile",
        iconKey: "userIcon",
        actionPath: Routes.PROFILE,
        label: "My Profile",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.PROFILE],
      },*/
      {
        key: "workLog",
        iconKey: "workLogIcon",
        actionPath: Routes.WORKLOG,
        label: "Work Logs",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.WORKLOG],
      },
      {
        key: "timeOff",
        iconKey: "timeOffIcon",
        actionPath: Routes.TIME_OFF,
        label: "Time off",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.TIME_OFF],
      },
      {
        key: "certifications",
        iconKey: "certificationIcon",
        actionPath: Routes.CERTIFICATIONS,
        label: "Certifications",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.CERTIFICATIONS],
      },
      {
        key: "invoiceGenerator",
        iconKey: "reportIcon",
        actionPath: Routes.INVOICE_GENERATOR,
        label: "Invoice Generator",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.INVOICE_GENERATOR],
      },
    ],
  },
  /* Feature is not being used currently.
  {
    key: "growthChallenge",
    label: "Growth Challenge",
    icon: <TrendingUpIcon />,
    items: [
      {
        key: "ranking",
        iconKey: "rankingIcon",
        actionPath: Routes.RANKING,
        label: "Leaderboard",
        tooltip: "Leaderboard",
        roles: RoleUtils.roleAccessDictionary[Routes.RANKING],
      },
      {
        key: "myAccomplishments",
        iconKey: "accomplishmentIcon",
        actionPath: Routes.ACCOMPLISHMENTS,
        label: "My Accomplishments",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.ACCOMPLISHMENTS],
      },
      {
        key: "accomplishmentApproval",
        iconKey: "accomplishmentApprovalIcon",
        actionPath: Routes.ACCOMPLISHMENT_APPROVAL,
        label: "Accomplishment Approval",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.ACCOMPLISHMENT_APPROVAL],
      },
    ],
  },
  */
  {
    key: "projectManagement",
    label: "Project Management",
    icon: <CreateNewFolderIcon />,
    items: [
      {
        key: "worklog-report",
        iconKey: "reportIcon",
        actionPath: Routes.WORKLOG_REPORT,
        label: "Worklogs Report",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.WORKLOG_REPORT],
      },
      {
        key: "projects",
        iconKey: "projectIcon",
        actionPath: Routes.PROJECTS,
        label: "Projects",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.PROJECTS],
      },
      /* Feature is not working as intended
      {
        key: "projects_timeline",
        iconKey: "projectTimelineIcon",
        actionPath: Routes.PROJECTS_TIMELINE,
        label: "Projects Timeline",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.PROJECTS_TIMELINE],
      },
      */
      {
        key: "positions",
        iconKey: "positionIcon",
        actionPath: Routes.POSITIONS,
        label: "Position",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.POSITIONS],
      },
      {
        key: "assignations",
        iconKey: "assignationIcon",
        actionPath: Routes.ASSIGNATIONS,
        label: "Assignations",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.ASSIGNATIONS],
      },
    ],
  },
  {
    key: "internal-reports",
    label: "Internal Reports",
    icon: <SummarizeIcon />,
    items: [
      {
        key: "worklogs-summary",
        iconKey: "worklogsSummaryIcon",
        actionPath: Routes.WORKLOGS_SUMMARY,
        label: "Worklogs Summary",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.WORKLOGS_SUMMARY],
      },
      {
        key: "assignation-projection",
        iconKey: "assignationProjectionIcon",
        actionPath: Routes.ASSIGNATION_PROJECTION,
        label: "Assignation Projection",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.ASSIGNATION_PROJECTION],
      },
      {
        key: "over-staff-report",
        iconKey: "userIcon",
        actionPath: Routes.OVER_STAFF_REPORT,
        label: "Staff Report",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.OVER_STAFF_REPORT],
      },
    ],
  },
  {
    key: "admin",
    label: "Admin",
    icon: <MonitorOutlinedIcon />,
    items: [
      {
        key: "users",
        iconKey: "userIcon",
        actionPath: Routes.USERS,
        label: "Users",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.USERS],
      },
      {
        key: "timeOffReport",
        iconKey: "reportIcon",
        actionPath: Routes.TIME_OFF_REPORT,
        label: "Time Off Report",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.TIME_OFF_REPORT],
      },
      {
        key: "unifiedReports",
        iconKey: "reportIcon",
        actionPath: Routes.UNIFIED_REPORTS,
        label: "Unified Reports",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.UNIFIED_REPORTS],
      },
      {
        key: "vacationReport",
        iconKey: "vacationReportIcon",
        actionPath: Routes.VACATION_REPORT,
        label: "Vacation Report",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.VACATION_REPORT],
      },
      {
        key: "worklogMissingHours",
        iconKey: "worklogMissingHoursIcon",
        actionPath: Routes.WORKLOG_MISSING_HOURS,
        label: "Worklog Missing Hours",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.WORKLOG_MISSING_HOURS],
      },
      {
        key: "timeOffMissingHours",
        iconKey: "timeOffMissingHoursIcon",
        actionPath: Routes.TIME_OFF_MISSING_HOURS,
        label: "Time Off External Report",
        tooltip: "Time Off External Report",
        roles: RoleUtils.roleAccessDictionary[Routes.TIME_OFF_MISSING_HOURS],
      },
      {
        key: "holidays",
        iconKey: "holidayIcon",
        actionPath: Routes.HOLIDAYS,
        label: "Holidays",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.HOLIDAYS],
      },
      {
        key: "sites",
        iconKey: "siteSectionIcon",
        actionPath: Routes.SITE,
        label: "Sites",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.SITE],
      },
      {
        key: "properties",
        iconKey: "propertiesSectionIcon",
        actionPath: Routes.PROPERTIES,
        label: "Properties",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.PROPERTIES],
      },
      {
        key: "badges",
        iconKey: "badgesSectionIcon",
        actionPath: Routes.BADGES,
        label: "Badges",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.BADGES],
      },
    ],
  },
  {
    key: "utils",
    label: "Utils",
    icon: <AppsIcon />,
    items: [
      {
        key: "imageTemplateBuilder",
        iconKey: "imagesearchRollerIcon",
        actionPath: Routes.IMAGE_TEMPLATE_BUILDER,
        label: "image template builder",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.IMAGE_TEMPLATE_BUILDER],
      },
    ],
  },
  {
    key: "others",
    label: "Others",
    icon: <MoreHorizOutlinedIcon />,
    items: [
      {
        key: "faqs",
        iconKey: "faqSectionIcon",
        actionPath: Routes.FAQS,
        label: "FAQS",
        tooltip: "",
        roles: RoleUtils.roleAccessDictionary[Routes.FAQS],
      },
    ],
  },
];

interface ItemType {
  [key: string]: JSX.Element;
}

interface PathToLandingPage {
  path: string;
  role: string;
}

export const defaultLandingPages: PathToLandingPage[] = [
  {
    path: Routes.DASHBOARD,
    role: AccessRoleType.ROLE_ADMIN,
  },
  {
    path: Routes.DASHBOARD,
    role: AccessRoleType.ROLE_MANAGER,
  },
  {
    path: Routes.DASHBOARD,
    role: AccessRoleType.ROLE_HR,
  },
  {
    path: Routes.DASHBOARD,
    role: AccessRoleType.ROLE_CONTRACTOR,
  },
];

export const getLandingPageByUser = (user: User): string | undefined => {
  for (const item of defaultLandingPages) {
    if (user.roles.some((role) => role.name === item.role)) {
      return item.path;
    }
  }
  return undefined;
};

export const GetNavigations = (navigations: string[]) => {
  const history = useHistory();
  const navigation = [];

  for (let nav of navigations) {
    switch (nav) {
      case Navigation.ASSIGNATIONS: {
        navigation.push({
          name: Navigation.ASSIGNATIONS,
          roles: RoleUtils.roleAccessDictionary[Routes.ASSIGNATIONS],
          icon: STATIC_ICONS.assignationIcon,
          onClick: () => history.push(Routes.ASSIGNATIONS),
        });
        break;
      }
      case Navigation.POSITIONS: {
        navigation.push({
          name: Navigation.POSITIONS,
          roles: RoleUtils.roleAccessDictionary[Routes.POSITIONS],
          icon: STATIC_ICONS.positionIcon,
          onClick: () => history.push(Routes.POSITIONS),
        });
        break;
      }
      case Navigation.WORKLOG_SUMMARY: {
        navigation.push({
          name: Navigation.WORKLOG_SUMMARY,
          roles: RoleUtils.roleAccessDictionary[Routes.WORKLOGS_SUMMARY],
          icon: STATIC_ICONS.worklogsSummaryIcon,
          onClick: () => history.push(Routes.WORKLOGS_SUMMARY),
        });
        break;
      }
      case Navigation.WORKLOG_REPORT: {
        navigation.push({
          name: Navigation.WORKLOG_REPORT,
          roles: RoleUtils.roleAccessDictionary[Routes.WORKLOG_REPORT],
          icon: STATIC_ICONS.workLogReportsIcon,
          onClick: () => history.push(Routes.WORKLOG_REPORT),
        });
        break;
      }
      default: {
        break;
      }
    }
  }
  return navigation;
};
